<template>
    <div class="CoverageFormat">
      <img
        src="/images/5CqSGjp.jpg"
        alt="Ethiopia internet connectivity and business landscape"
        class="banner-img CoverageFormat__saturation"
      />
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION</strong> - 117.8 million*</li>
            <li>
              <strong>NEIGHBOURING COUNTRIES*</strong> - It is bordered by the 
              <strong>Sudan</strong> in the west, Somalia and Djibouti in the east, Eritrea in the north, and Kenya in the south.
              <ul>
                <li>It is the 10th largest country in Africa.</li>
                <li>The 2nd-most populous country in Africa after Nigeria.</li>
                <li>100 mts. Below sea level lowest pt.</li>
                <li>4620 mts the highest pt.. Ras Dashen.</li>
              </ul>
            </li>
            <li><strong>LANGUAGE SPOKEN</strong> - <strong>Amharic</strong> is the government's official language, and Oromo is widely spoken by over a third of the population.</li>
            <li><strong>CURRENCY</strong> - <strong>The Ethiopian birr (ETB)</strong>.</li>
            <li><strong>INDUSTRIES</strong> - Food processing, textiles, leather, chemicals, and cement.</li>
            <li><strong>EMPLOYMENT*</strong> - <strong>10.35%</strong> of total employment in industry (World Bank 2020).</li>
            <li><strong>TOP 3 CITIES</strong> - Addis Ababa (Finfinne), Dire Dawa, Mek'ele.</li>
            <li><strong>WEATHER</strong> - Ethiopia has a largely arid climate with variable precipitation.</li>
            <li><strong>NATIONAL SPORT</strong> - <strong>Football</strong>.</li>
          </ul>
  
          <div class="text-center">
            <img
              src="https://gistcdn.githack.com/juan-bits/273b46b3dc5f2b8b5c28d29c610ae7fb/raw/aed7f61b45f84619ccb81300278b5e919a97f354/ethiopia-flag.svg"
              alt="Ethiopian flag"
              class="my-5"
              style="width: 150px"
            />
          </div>
        </nav>
  
        <article>
          <h2>Ethiopia: A Land of Opportunities and Connectivity</h2>
          <p>
            Ethiopia, located in the Horn of Africa, is a landlocked country with rich cultural heritage. It is strategically positioned to access international trade routes, making it an important regional hub.
          </p>
  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7388883.609510792!2d36.526389358997605!3d8.06756548664737!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1635d0cedd6cfd2b%3A0x7bf6a67f5348c55a!2sEthiopia!5e0!3m2!1sen!2ses!4v1644315762590!5m2!1sen!2ses"
            width="95%"
            height="450"
            title="Ethiopia Map"
            class="CoverageFormat__margins"
            style="border: 0"
            allowfullscreen
            loading="lazy"
          ></iframe>
  
          <h3 class="mt-4">Tourism and Economy</h3>
          <p>
            Ethiopia's rich history, including ancient sites like Lalibela and Aksum, attracts thousands of tourists each year. The country's economic landscape, fueled by industries like textiles and food processing, is growing rapidly.
          </p>
  
          <h3 class="mt-4">Connectivity and Internet Providers</h3>
          <p>
            Ethiopia's internet penetration is on the rise, with more than 23.96 million users reported in 2021. There are currently six local internet providers, and inte-QT partners with three key players to offer comprehensive services across the country.
          </p>
  
          <table class="table table-striped table-responsive">
            <thead>
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Millions</th>
                <th scope="col">Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Broadband users</td>
                <td>21.5 m</td>
                <td>18.5 %</td>
              </tr>
              <tr>
                <td>Landlines</td>
                <td>21.1 m</td>
                <td>18.4 %</td>
              </tr>
              <tr>
                <td>Mobile cellulars</td>
                <td>44.77 m</td>
                <td>38.5 %</td>
              </tr>
              <tr>
                <td>Access to internet</td>
                <td>23.96 m</td>
                <td>20.6 %</td>
              </tr>
            </tbody>
          </table>
  
          <h4 class="my-4">Our Capabilities</h4>
          <table class="table table-striped mb-5">
            <tbody>
              <tr>
                <td>Dedicated Lines</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
              <tr>
                <td>Business Broadband</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
              <tr>
                <td>Wireless Connect</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
              <tr>
                <td>CPE / Router</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
              <tr>
                <td>GEMS</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
              <tr>
                <td>Diverse Gateway Solutions</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
              <tr>
                <td>DDoS</td>
                <td><i class="fas fa-check"></i></td>
              </tr>
            </tbody>
          </table>
  
          <p class="CoverageFormat__tag CoverageFormat__margins" align="justify">
            Get a commercial offer in 2-3 working days. Services can be delivered in 15 to 20 working days. 
          </p>
  
          <p class="text-center">
            For more information, please 
            <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>
          </p>
  
          <h4>* - References</h4>
          <ul>
            <li><a href="https://ethiopianembassy.org" target="_blank" rel="noopener noreferrer">Reference 1</a></li>
            <li><a href="https://www.britannica.com" target="_blank" rel="noopener noreferrer">Reference 2</a></li>
            <li><a href="https://freedomhouse.org/country/ethiopia/freedom-net/2020" target="_blank" rel="noopener noreferrer">Reference 3</a></li>
            <li><a href="https://datareportal.com/reports/digital-2021-ethiopia" target="_blank" rel="noopener noreferrer">Reference 4</a></li>
            <li><a href="https://absoluteethiopia.com/" target="_blank" rel="noopener noreferrer">Reference 5</a></li>
          </ul>
        </article>
      </section>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import GetInTouch from '@/components/GetInTouch.vue';
  
  export default {
    name: 'EthiopiaPage',
    components: {
      GetInTouch,
    },
    metaInfo() {
      return {
        title: 'Internet Connectivity and Business Solutions in Ethiopia - inte-QT',
        meta: [
          {
            name: 'description',
            content:
              'Learn about internet connectivity in Ethiopia, local providers, and how inte-QT can help with broadband, business solutions, and more.',
          },
          {
            name: 'keywords',
            content:
              'internet connectivity, Ethiopia, broadband, mobile, telecommunications, internet providers, Ethiopia business solutions',
          },
          {
            property: 'og:title',
            content: 'Internet Connectivity and Business Solutions in Ethiopia - inte-QT',
          },
          {
            property: 'og:description',
            content:
              'Explore Ethiopia’s internet usage, providers, and how inte-QT offers global business solutions in the country.',
          },
          {
            property: 'og:image',
            content: 'https://www.inte-qt.com/images/5CqSGjp.jpg',
          },
          {
            property: 'og:url',
            content: 'https://www.inte-qt.com/coverage/ethiopia',
          },
          {
            rel: 'canonical',
            href: 'https://www.inte-qt.com/coverage/ethiopia',
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
.CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  